import { combineReducers } from 'redux';

import apiTokenReducer from './apiToken/data/reducer';
import apiTokenSaga, {
  initSaga as apiTokenInitSaga,
} from './apiToken/data/sagas';
import webhookCreateEditDrawerReducer from './webhookCreateEditDrawer/data/reducer';

const initSaga = function* () {
  yield apiTokenInitSaga();
};

const reducer = combineReducers({
  apiToken: apiTokenReducer,
  webhookCreateEditDrawer: webhookCreateEditDrawerReducer,
});

const saga = function* () {
  yield apiTokenSaga();
};

export { initSaga, reducer, saga };
